module.exports = __webpack_public_path__ + "media/images/lb/798-e98444b77ca3a6df2e496bf25f2dfd8c.svg";